import {Button} from "@mui/material";
import {Link as RouterLink} from "react-router";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AppRoute from "../routing/AppRoute";

export const BackButton = () => (
    <Button
        component={RouterLink}
        to={AppRoute.HOME}
        startIcon={<ArrowBackIcon/>}
        sx={{
            color: 'text.secondary',
            fontWeight: 'bold',
            padding: '8px',
            borderRadius: '8px',
            '&:hover': {
                color: 'text.primary',
                backgroundColor: 'rgba(249, 249, 249, 0.15)',
            },
        }}
    >
        Home
    </Button>
)